import { IValidator } from './IValidator';
import { ScaleInfo } from '../ScaleInfo';

declare let THREE: any;

export class WallNeighbourTierRestrictionValidator implements IValidator {

  constructor(private scaleInfo: ScaleInfo) {
  }

  private tierTypeSettingsMap = {
    tier1StepUp: {
      distanceToTier: 0
    },
    tier2StepUp: {
      distanceToTier: 22.86
    },
    tier3StepUp: {
      distanceToTier: 45.72
    },
    tier1StepDown: {
      distanceToTier: 0
    },
    tier2StepDown: {
      distanceToTier: 22.86
    },
    tier3StepDown: {
      distanceToTier: 45.72
    }
  };

  private static isBetweenPoints(start, end, pointToCheck) {
    const ab = start.clone().sub(pointToCheck).normalize();
    const bc = end.clone().sub(pointToCheck).normalize();
    return ab.dot(bc) <= 0.1;
  }

  private staticSidePoint(wall, wallLength) {
    const point = this.scaleInfo.localScaleDirection.clone().negate().multiplyScalar(wallLength);
    wall.updateMatrixWorld();
    return wall.localToWorld(point).setY(0);
  }

  private dynamicSidePoint(staticSidePoint, newWallLength) {
    const offset = this.scaleInfo.worldScaleDirection.clone().multiplyScalar(newWallLength);
    return staticSidePoint.clone().add(offset);
  }

  private scaleTowardPointWithTier(start, end) {
    const endToStart = start.clone().sub(end).normalize();
    return this.scaleInfo.worldScaleDirection.dot(endToStart) >= 0.9;
  }

  private isTierNearBy(wall, edgeStart, edgeEnd): boolean {
    const { secondPoint, previousPoint } = wall.userData.config;

    const secondPointHasTier = secondPoint.superstructureType &&
      secondPoint.superstructureType.includes('tier') &&
      this.scaleTowardPointWithTier(edgeEnd, edgeStart);

    const firstPointHasTier = previousPoint.superstructureType &&
      previousPoint.superstructureType.includes('tier') &&
      this.scaleTowardPointWithTier(edgeStart, edgeEnd);

    return secondPointHasTier || firstPointHasTier;
  }

  validate(wall, newSize, newPosition): boolean {

    wall.updateMatrixWorld();
    const { firstPoint, secondPoint, previousPoint, width: wallLength } = wall.userData.config;
    const edgeStart = new THREE.Vector3(firstPoint.x, 0, firstPoint.y);
    const edgeEnd = new THREE.Vector3(secondPoint.x, 0, secondPoint.y);
    if (previousPoint.superstructureType &&
      previousPoint.superstructureType.includes('tier')) {
      let endToStart = edgeStart.clone().sub(edgeEnd);
      endToStart.setLength(this.tierTypeSettingsMap[previousPoint.superstructureType].distanceToTier);
      edgeStart.add(endToStart);
    }
    if (secondPoint.superstructureType &&
      secondPoint.superstructureType.includes('tier')) {
      let startToEnd = edgeEnd.clone().sub(edgeStart);
      startToEnd.setLength(this.tierTypeSettingsMap[secondPoint.superstructureType].distanceToTier);
      edgeEnd.add(startToEnd);
    }
    const dynamicSidePoint = this.dynamicSidePoint(this.staticSidePoint(wall, wallLength / 2), newSize.x);

    if (this.isTierNearBy(wall, edgeStart, edgeEnd)) {
      return WallNeighbourTierRestrictionValidator.isBetweenPoints(edgeStart, edgeEnd, dynamicSidePoint);
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/Validators/WallNeighbourTierRestrictionValidator.ts